import { useCurrentUserSuspenseQuery } from "@/api/queries/useCurrentUserSuspenseQuery"
import { scheduleQueryKeys } from "toptaal-shared"
import { fetchUserSchedule } from "@/api/services/schedule"
import { CalendarWithModal } from "@/components/modals/calendar/CalendarWithModal"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/profiel/agenda/")({
  component: RouteComponent,
})

function RouteComponent() {
  const { data: user } = useCurrentUserSuspenseQuery()

  return (
    <CalendarWithModal
      id={user.data.userId}
      getQueryKey={scheduleQueryKeys.user}
      queryFn={({ id, startDate, endDate }) =>
        fetchUserSchedule({ id, startDate, endDate })
      }
    />
  )
}
